export const DWMY_RANGES = [
  { id: '1D', displayValue: '1D' },
  { id: '1W', displayValue: '1W' },
  { id: '1M', displayValue: '1M' },
  { id: '3M', displayValue: '3M' },
  { id: '6M', displayValue: '6M' },
  { id: '1Y', displayValue: '1Y' },
  { id: '2Y', displayValue: '2Y' },
];
